module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_NEED_HELP.5b818e53.svg";